{
  "timeValidationError": "Die Minute sollte zwischen 00 und 59 liegen",
  "startEndTimeValidationError": "Die Endzeit sollte nach der Startzeit liegen",
  "Eq": "Entspricht",
  "Gt": "Größer als",
  "Gte": "Größer als oder gleich",
  "Lt": "Weniger als",
  "Lte": "Weniger als oder gleich",
  "Ct": "Enthält",
  "deleteRow": "Zeile löschen",
  "addRow": "Neue Zeile hinzufügen",
  "addColumn": "Spalte hinzufügen",
  "deleteAll": "Alles löschen",
  "uploadData": "Daten hochladen",
  "deleteExisting": "Bestehende Artikel löschen",
  "keepExisting": "Bestehende Artikel behalten",
  "downloadData": "Daten herunterladen",
  "schedule": {
    "day": "Tag",
    "date": "Datum",
    "start": "Beginn",
    "end": "Ende",
    "duration": "Dauer (Minuten)",
    "venue": "Veranstaltungsort",
    "space": "Weltraum",
    "type": "Typ",
    "Discipline": "Disziplin",
    "zero": "Null",
    "description": "Beschreibung"
  },
  "toasts": {
    "edit_success": "Zelle wurde erfolgreich bearbeitet",
    "edit_error": "Fehler beim Bearbeiten der Zelle. Erwägen Sie, die Zellen zu aktualisieren",
    "insert_success": "{{ type }} wurde erfolgreich hinzugefügt",
    "insert_error": "Fehler beim Einfügen der Zeile. Erwägen Sie, die Zellen zu aktualisieren",
    "delete_success": "Zeilenentität wurde erfolgreich gelöscht",
    "delete_error": "Fehler beim Löschen der Zeile. Erwägen Sie, die Zellen zu aktualisieren",
    "refresh_cells": "Zellen aktualisieren"
  },
  "dataTable": {
    "filter": {
      "equals": "Entspricht",
      "greaterThan": "Größer als",
      "greaterThanOrEqualTo": "Größer als oder gleich",
      "lessThan": "Weniger als",
      "lessThanOrEqualTo": "Weniger als oder gleich",
      "contains": "Enthält",
      "select_all": "Alles auswählen"
    }
  },
  "type_something": "Geben Sie {{ name }} ein",
  "group": "Gruppe",
  "count_column_header": "(Anzahl)",
  "none_group": "Keine",
  "Export selected rows only": "Nur ausgewählte Zeilen exportieren",
  "Export all": "Alle exportieren",
  "from": "Von",
  "to": "Zu"
}